import Footer from "../components/Footer.tsx";
import VerifyForm from "../components/login/VerifyForm.tsx";
import { SubmitProvider } from "../context/context.submit";
import CurrentEmail from "../components/auth/core/CurrentEmail.tsx";
import SEO from "../components/core/SEO.tsx";
import { ROUTE_VERIFY } from "../const/routes.ts";
import Logout from "../components/Logout.tsx";

const Verify = () => {
  return (
    <div className="safe-bottom-with-dock safe-top min-h-lvh flex flex-col">
      <SEO title="E-Mail bestätigen" noIndex url={ROUTE_VERIFY()} />
      <main className="flex flex-col grow justify-center items-center p-page min-h-screen">
        <div className="rounded-box bg-base-200 p-8">
          <div className="flex flex-col gap-5">
            <h2 className="text-3xl font-bold text-center">
              Bestätige deine E-Mail
            </h2>
            <p className="truncate">
              <CurrentEmail />
            </p>
            <SubmitProvider iButtonElem={"Jetzt verifizieren"}>
              <div className="badge badge-lg h-auto">
                Du hast eine E-Mail mit dem Verifizierungscode bekommen. Bitte
                gib den 6-stelligen Code jetzt ein.
              </div>
              <VerifyForm />
            </SubmitProvider>
            <Logout />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Verify;
